// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"62":"b4f49957","96":"a6f97bde","99":"8774ed6f","157":"03048472","366":"1d1e3463","566":"3c1b2a5a","658":"a02fea41","774":"6e8e36ad"}[chunkId] + ".chunk.js";
};